<template>
  <SmartLinkItemComponent :id="model.system.id" :component="!model.system.workflow" :custom-tag="fromFooter ? 'li' : 'span'">
    <SmartLinkStandaloneElement :codename="typ.elements.label.codename" class="contact-item address">
      <span>
        <font-awesome class="contact-icon fa-fw" :icon="showIcon" />
      </span>

      <span v-if="model.elements.label.value" class="contact-label">{{ model.elements.label.value }}</span>

      <span>
        <div class="rich-text">
          <RichText :value="model.elements.address.value" />
        </div>
      </span>
    </SmartLinkStandaloneElement>
  </SmartLinkItemComponent>
</template>
<script lang="ts" setup>
import type { Elements } from '@kontent-ai/delivery-sdk';
import { contentTypes } from '~/models'
import type { ContactItemAddressModel } from '~/models'
const typ = contentTypes._contact_item___address
const props = defineProps<{ model: ContactItemAddressModel, fromFooter: boolean }>()
const showIcon = getIcon(props.model.elements.showIcon)


function getIcon(answer?: Elements.MultipleChoiceElement) {
  if(answer?.value && answer.value.length > 0) {
      const choice = answer.value[0];
      switch (choice.codename) {
          case 'yes_pin':
              return 'location-dot';
          case 'yes_envelope':
              return 'envelope';
          case 'no':
              return '';
          default:
              return 'location-dot';
      }
  }
  return 'location-dot';
}
</script>
